import * as toastsActions from '@zola/zola-ui/src/actions/toastsV2Actions';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

import { AppThunk } from '~/reducers';
import { MappedInquiryView } from '~/types/mappedResponseTypes';

export const showExistingInquiryError = (inquiry: MappedInquiryView): AppThunk<void> => {
  return (dispatch) => {
    dispatch(
      toastsActions.negative({
        headline: "You've already inquired with this vendor.",
        dek: (
          <LinkV2 noTextTransform href={`/wedding-vendors/inquiries/${inquiry.uuid}`} arrow>
            View inquiry
          </LinkV2>
        ),
        autoDismissInSeconds: 15,
        dismissText: 'Close',
      })
    );
  };
};
